<template>
  <div class="flex flex-1 min-h-0 box-border">
    <div class="flex flex-col w-full">
      <div class="flex space-x-6 mb-4 items-center">
        <router-link
          v-for="lang in langs"
          :key="lang.code"
          :to="{ name: 'articles-lang', params: { lang: lang.code } }"
          class="cursor-pointer font-bold m-0 text-xl text-black nav-item"
        >
          {{ lang.name }}
        </router-link>
      </div>

      <router-view :key="activeRouteLang" />
    </div>
  </div>
</template>

<script>
import { computed, ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { useCountries } from '@/composables/countries'

export default {
  setup () {
    const route = useRoute()
    const router = useRouter()

    const { langs } = useCountries({ activeCountry: ref(route.params.country) })
    const activeRouteLang = computed(() => route.params.lang)

    onMounted(() => {
      if (route.name !== 'articles-country') return

      router.replace({
        name: 'articles-lang',
        params: {
          lang: langs.value[0].code,
          country: route.params.country
        }
      })
    })

    return {
      langs,
      activeRouteLang
    }
  }
}
</script>

<style lang="postcss" scoped>
.nav-item:not(.router-link-active) {
  @apply opacity-30;
}
</style>
